/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleLocksResponse } from '../../models/article-locks-response';
import { KeyType } from '../../models/key-type';

export interface GetCheckinArticleLocks$Params {
  organizationSiteKey: KeyType;
  checkinKey: string;
}

export function getCheckinArticleLocks(http: HttpClient, rootUrl: string, params: GetCheckinArticleLocks$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleLocksResponse>> {
  const rb = new RequestBuilder(rootUrl, getCheckinArticleLocks.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleLocksResponse>;
    })
  );
}

getCheckinArticleLocks.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/article-locks';
